import { useState } from 'react';
import { Save, TestTube } from 'lucide-react';
import { API_URL } from '../config/api';

const ResultForm = ({ sampleId, onSuccess }) => {
    const [findings, setFindings] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const response = await fetch(`${API_URL}/results`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    sample_id: sampleId,
                    findings: findings,
                    result_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
                    numerical_values: {} // Optional for now
                })
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Resultado guardado. El flujo se ha actualizado.');
                setFindings('');
                if (onSuccess) onSuccess();
            } else {
                setMessage(data.message || 'Error al guardar resultado');
            }
        } catch (error) {
            setMessage('Error de conexión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card result-form-card">
            <h4><TestTube size={18} /> Capturar Resultado</h4>
            {message && <div className={`alert ${message.includes('Error') ? 'alert-error' : 'alert-success'}`}>{message}</div>}

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Hallazgos / Resultado</label>
                    <textarea
                        value={findings}
                        onChange={(e) => setFindings(e.target.value)}
                        placeholder="Escriba el resultado (ej. POSITIVO, NEGATIVO, DETECTADO...)"
                        required
                        rows="4"
                        className="form-control"
                    ></textarea>
                    <small className="text-muted">
                        Nota: Si escribe "POSITIVO" en la primera muestra, se generará automáticamente la segunda muestra.
                    </small>
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                    <Save size={18} /> {loading ? 'Guardando...' : 'Guardar Resultado'}
                </button>
            </form>
        </div>
    );
};

export default ResultForm;
